import { locationMap } from '~/../locationMap.js.erb'

$(function() {
  if ($('body.machines').length == 0) {
    return;
  }
  locationMap('machineLocationMap');
})